export default "/assets/images/mila-feed-01.mp4?689ff709360aab95d8a9aa52bffc2343";